import React from 'react';
import { Flex, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Button } from '@bettercomp/ui-components';

import { SurveySeasonBadge } from './SurveySeasonBadge';
import SurveyRefreshWorkflowIllustration from './survey-refresh-workflow.svg';
import cn from './styles.module.scss';

type NotStartedBannerProps = {
  onGetStarted?: () => void;
  onClose?: () => void;
};

export function NotStartedBanner({ onGetStarted, onClose }: NotStartedBannerProps) {
  return (
    <Flex align="center" gap={32} className={cn.content}>
      <SurveyRefreshWorkflowIllustration aria-hidden className={cn.illustration} />
      <Flex vertical gap={8} className={cn.body}>
        <SurveySeasonBadge label="Survey Refresh Workflow" />
        <Typography.Title level={4} className={cn.title}>Get started on your next plan</Typography.Title>
        <Typography.Paragraph className={cn.description}>
          Select your surveys, track when survey results are available, then activate your new plan and
          review survey job and cut mappings. You can save your progress and come back anytime.
        </Typography.Paragraph>
      </Flex>
      <Flex align="center" gap={8} className={cn.action}>
        <Button
          type="primary"
          size="large"
          onClick={onGetStarted}
          data-testid="surveySeasonGetStartedButton"
        >
          Get Started
        </Button>
        {onClose && (
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={onClose}
            data-testid="surveySeasonCloseButton"
            aria-label="Dismiss"
            className={cn.closeButton}
          />
        )}
      </Flex>
    </Flex>
  );
}
